import { useQuery } from "@tanstack/react-query";

import { quotaQueryKeys } from "app/pages/sales-intelligence/modules/quota/queries/keys";
import { useDataCreditsQuery } from "app/pages/sales-intelligence/modules/quota/queries/useDataCreditsQuery";
import salesApiService from "app/pages/sales-intelligence/services/salesApiService";
import salesSettingsHelper from "app/pages/sales-intelligence/services/salesSettingsHelper";

import type { QuotaOperationState } from "../types";

export const useContactsQuotaQuery = (enabled: boolean = true) => {
    const isDataCreditsEnabled = salesSettingsHelper.isDataCreditsEnabled;

    const dataCreditsQuery = useDataCreditsQuery({ select: (data) => data.exportsState });

    const legacyQuery = useQuery<QuotaOperationState>({
        queryKey: quotaQueryKeys.contactsQuota(),
        enabled: enabled && !isDataCreditsEnabled,
        staleTime: 0,
        queryFn({ signal }) {
            return salesApiService.quota.fetchContactsQuota({ cancellation: signal });
        },
    });

    return isDataCreditsEnabled ? dataCreditsQuery : legacyQuery;
};
